import React, { useState } from 'react';
import { apiUrl } from '../../../config'
import { fetchData } from '../../../utils/api';
import styles from '../../../styles/scss/system/Users.module.scss';
import { useAdminLanguage } from '../../../AdminLanguageContext';
import { translateAdmin } from '../../../utils/adminTranslations';

const UserEdit = ({ user, rolesData, onClose, onSaved, canChangeRole }) => {
    const { language } = useAdminLanguage();
    const translate = (text) => translateAdmin(text, language);
    const [editUser, setEditUser] = useState({
        ...user,
        "old_password": '',
        "new_password": ''
    });
    const [roles] = useState(rolesData);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditUser((prevUser) => ({ ...prevUser, [name]: value }));
    };

    const sendData = async () => {
        const requestData = {
            username: editUser.username,
            first_name: editUser.first_name,
            last_name: editUser.last_name,
            old_password: editUser.old_password,
            new_password: editUser.new_password,
            role_id: editUser.role_id,
            position: editUser.position,
        };

        const token = localStorage.getItem('accessToken');

        const data = await fetchData(`${apiUrl}/api/sys/edit-user`, "POST", token, { body: requestData })
        if (data.request.status === 0) {
            await onSaved();
            onClose();
        }
        alert(translate(Array.isArray(data.request.message) ? data.request.message.join('\n') : data.request.message));
    };


    return (
        <div className={styles.modalOverlay} role="presentation">
            <section className={styles.modalDialog} role="dialog" aria-modal="true" aria-labelledby="edit-user-title">
                <header className={styles.modalHeader}>
                    <div>
                        <span className={styles.eyebrow}>{translate('УПРАВЛЕНИЕ ДОСТУПОМ')}</span>
                        <h2 id="edit-user-title">{translate('Изменить пользователя')}</h2>
                        <p>{translate('Обновите данные сотрудника, роль или пароль.')}</p>
                    </div>
                    <button type="button" className={styles.modalClose} onClick={onClose} aria-label={translate('Закрыть')}>×</button>
                </header>
                <form className={styles.modalForm}>
                    <div className={styles.modalFields}>
                        <label className={styles.modalField}>
                            <span>{translate('Логин')}</span>
                            <input required placeholder={translate('Имя пользователя')} value={editUser.username} type="text" name='username' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Имя')}</span>
                            <input required placeholder={translate('Имя')} value={editUser.first_name} type="text" name='first_name' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Фамилия')}</span>
                            <input required placeholder={translate('Фамилия')} value={editUser.last_name} type="text" name='last_name' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Должность')}</span>
                            <input required placeholder={translate('Должность')} value={editUser.position || ''} type="text" name='position' onChange={handleInputChange} />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Старый пароль')}</span>
                            <input placeholder={translate('Введите текущий пароль')} value={editUser.old_password} type="password" name="old_password" onChange={handleInputChange} autoComplete="current-password" />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Новый пароль')}</span>
                            <input placeholder={translate('Введите новый пароль')} value={editUser.new_password} type="password" name="new_password" onChange={handleInputChange} autoComplete="new-password" />
                        </label>
                        <label className={styles.modalField}>
                            <span>{translate('Роль')}</span>
                            <select
                                required
                                value={editUser.role_id || ''}
                                onChange={handleInputChange}
                                name='role_id'
                                disabled={!canChangeRole}
                            >
                                {roles && roles.length > 0 ? (
                                    roles.map((role) => (
                                        <option key={role.id} value={role.id}>{translate(role.role_name)}</option>
                                    ))
                                ) : (
                                    <option value="">{translate('Нет ролей')}</option>
                                )}
                            </select>
                            {!canChangeRole && <small>{translate('Свою роль изменить нельзя.')}</small>}
                        </label>
                    </div>
                    <footer className={styles.modalFooter}>
                        <button type='button' className={styles.secondaryButton} onClick={onClose}>{translate('Отмена')}</button>
                        <button type='button' className={styles.createButton} onClick={() => sendData(editUser)}>{translate('Сохранить изменения')}</button>
                    </footer>
                </form>
            </section>
        </div>
    );
}

export default UserEdit;